import getFromCdn from '@anm/helpers/getFromCdn';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  padding-bottom: 16px;
`;

export const BackArrow = styled.div`
  top: 2px;
  left: -3px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  transform: rotate(90deg);
  background: url(${getFromCdn('images/dropdown_arrow_black.svg')}) 8px/15px no-repeat;
`;
